import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 0 24px;
  height: 100%;
  color: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default Wrapper
